export const clearLocalStorage = () => {
  const selectedMarket = window.localStorage.getItem("selectedMarket");
  const passkeyOptOut = window.localStorage.getItem("passkey-opt-out");
  const market = window.localStorage.getItem("mindlercare:market");
  const lastLoginOption = window.localStorage.getItem(
    "auth:last-sign-in-option",
  ); // todo: this should be handled by auth library i believe
  const showDebugInfo = window.localStorage.getItem(
    "mindlercare:show-debug-info",
  );
  window.localStorage.clear();

  if (selectedMarket) {
    window.localStorage.setItem("selectedMarket", selectedMarket);
  }

  if (passkeyOptOut) {
    window.localStorage.setItem("passkey-opt-out", passkeyOptOut);
  }

  if (market) {
    window.localStorage.setItem("mindlercare:market", market);
  }
  if (lastLoginOption) {
    window.localStorage.setItem("auth:last-sign-in-option", lastLoginOption);
  }
  if (showDebugInfo) {
    window.localStorage.setItem("mindlercare:show-debug-info", showDebugInfo);
  }
};
